import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

export const ImageCrop = (p: ReactCrop.ReactCropProps) => {
  return <ReactCrop {...p} />;
};
